import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { resourceService } from '@libs/axios';
import { ResponseType } from '@store/index';
import {
    fetchTaskJobs,
    retryTaskJob,
    cancelTaskJob,
    deleteTaskJob,
} from '@store/actions/taskJobActions';
import {
    setTaskJobList,
    setLoading,
    setActionLoading,
} from '@store/reducers/taskJobReducer';

const API_URL = process.env.REACT_APP_API_URL;

function* fetchTaskJobsSaga(action: ReturnType<typeof fetchTaskJobs>) {
    yield put(setLoading(true));
    const { page, page_size, task_type, status, username } = action.payload;
    const params: Record<string, any> = { page, page_size };
    if (task_type) params.task_type = task_type;
    if (status) params.status = status;
    if (username) params.username = username;

    try {
        const response: ResponseType = yield call(
            resourceService.get,
            `${API_URL}/api/task_history/`,
            { params },
        );
        if (response.status === 200) {
            yield put(setTaskJobList(response.data));
        } else {
            toast.error(response.data?.detail || response.data?.error || 'Không thể tải danh sách tác vụ');
        }
    } catch (error: any) {
        toast.error(error?.response?.data?.detail || error?.response?.data?.error || 'Không thể tải danh sách tác vụ');
    } finally {
        yield put(setLoading(false));
    }
}

function* retryTaskJobSaga(action: ReturnType<typeof retryTaskJob>) {
    const { taskId } = action.payload;
    yield put(setActionLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.post,
            `${API_URL}/api/task_history/${taskId}/retry/`,
        );
        if (response.status === 202) {
            toast.success('Đã gửi yêu cầu chạy lại tác vụ');
        } else {
            toast.error(response.data?.detail || 'Không thể chạy lại tác vụ');
        }
    } catch (error: any) {
        toast.error(error?.response?.data?.detail || 'Không thể chạy lại tác vụ');
    } finally {
        yield put(setActionLoading(false));
    }
}

function* cancelTaskJobSaga(action: ReturnType<typeof cancelTaskJob>) {
    const { taskId } = action.payload;
    yield put(setActionLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.post,
            `${API_URL}/api/task_history/${taskId}/cancel/`,
        );
        if (response.status === 200) {
            toast.success('Đã hủy tác vụ');
        } else {
            toast.error(response.data?.detail || 'Không thể hủy tác vụ');
        }
    } catch (error: any) {
        toast.error(error?.response?.data?.detail || 'Không thể hủy tác vụ');
    } finally {
        yield put(setActionLoading(false));
    }
}

function* deleteTaskJobSaga(action: ReturnType<typeof deleteTaskJob>) {
    const { taskId } = action.payload;
    yield put(setActionLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.delete,
            `${API_URL}/api/task_history/${taskId}/remove/`,
        );
        if (response.status === 200) {
            toast.success('Đã xóa tác vụ khỏi lịch sử');
        } else {
            toast.error(response.data?.detail || 'Không thể xóa tác vụ');
        }
    } catch (error: any) {
        toast.error(error?.response?.data?.detail || 'Không thể xóa tác vụ');
    } finally {
        yield put(setActionLoading(false));
    }
}

export default function* taskJobSagas() {
    yield takeLatest(fetchTaskJobs, fetchTaskJobsSaga);
    yield takeLatest(retryTaskJob, retryTaskJobSaga);
    yield takeLatest(cancelTaskJob, cancelTaskJobSaga);
    yield takeLatest(deleteTaskJob, deleteTaskJobSaga);
}
